import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductRealTimeInventory } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    FindWarehouseData,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";

addToChainAfter(chain, FindWarehouseData, props => {
    if (props.apiResult?.additionalResults) {
        const qtyOnHandForUOM = props.apiResult.additionalResults[props.parameter.unitOfMeasure.toLowerCase()];
        (props.result as any).qtyOnHand = qtyOnHandForUOM;
    } else {
        (props.result as any).qtyOnHand = props.apiResult?.qtyOnHand || 0;
    }
});

replaceInChain(chain, RequestDataFromApi, async props => {
    /* Poolcorp Custom Code */
    await getProductRealTimeInventory(props.apiParameter).then(
        result => {
            props.apiResult = result;
        },
        () => {},
    );
    /* Poolcorp Custom Code */
});
